import {initElements} from "../define/shared"
import {createApp} from "vue";
import LegalQuestionApp from "./legal-question/LegalQuestionApp";

export default function initLegalQuestionBlock() {
    initElements("#legal-question-app", appEl => {
        const dataEl = appEl.querySelector('[type="application/json"]')
        const props = JSON.parse(dataEl.innerText || '{}');
        const app = createApp(LegalQuestionApp, props);

        app.mount(appEl)
    })
}
